module.exports = __webpack_public_path__ + "img/prev.d72d45ef.svg";